import { useCanvasStageOperations } from 'state/canvas/stage';

interface Point {
  x: number;
  y: number;
}

type UseTranslateWindowPointToCanvas = (point: Point) => Point;

export default function useTranslateWindowPointToCanvas(
  surfaceId?: string,
): UseTranslateWindowPointToCanvas {
  const { getCanvasStage } = useCanvasStageOperations();

  return function translateWindowPointToCanvas(point: Point): Point {
    const stage = getCanvasStage();
    const scale = stage.scale;

    return {
      x: (point.x - stage.x) / scale,
      y: (point.y - stage.y) / scale,
    };
  };
}
